module.exports = __webpack_public_path__ + "img/MOUSTACHES SET 1 BW.f46d267.svg";